export default "__VITE_ASSET__DaFIjtVo__"